if (!customElements.get("gift-message")) {
  customElements.define(
    "gift-message",
    class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector("#GiftMessageCheckbox");
        this.form_container = this.querySelector("#GiftMessage");
      }
      connectedCallback() {
        this.checkbox.addEventListener("change", () => {
          if (this.checkbox.checked) {
            this.form_container.classList.add("gift-message__form--show");
            this.form_container
              .querySelector("#to_message")
              .removeAttribute("disabled");
              this.form_container
              .querySelector("#from_message")
              .removeAttribute("disabled");
          } else {
            this.form_container.classList.remove("gift-message__form--show");
            this.form_container
              .querySelector("#to_message")
              .setAttribute("disabled", true);
              this.form_container
              .querySelector("#from_message")
              .setAttribute("disabled", true);
          }
        });

        this.form_container.addEventListener("keyup", () => {
          this.onTextInputChange()
        })
      }
      onTextInputChange() {
        this.maxLimit = 250
        this.totalCharCount = 0
        this.charRemaining = 0
        this.toFieldCount = 0
        this.toFieldLimit = 0
        this.fromFieldCount = 0
        this.fromFieldLimit = 0
        this.msgFieldCount = 0
        this.msgFieldLimit = 0

        this.form_container.querySelectorAll('[name]').forEach(input => {
          this.totalCharCount += input.value.length;
          this.charRemaining = this.maxLimit - this.totalCharCount;
  
          if(input.id == 'to_message') {
            this.toFieldCount = input.value.length;
          }
          if(input.id == 'from_message') {
            this.fromFieldCount = input.value.length;
          }
          if(input.id == 'message') {
            this.msgFieldCount = input.value.length;
          }
        });

        // Calculates each field limit based on the current text content
        this.toFieldLimit = this.toFieldCount + this.charRemaining;
        this.fromFieldLimit = this.fromFieldCount + this.charRemaining;
        this.msgFieldLimit = this.msgFieldCount + this.charRemaining;

        //Sets updated max length to all fields after latest keyup count
        this.form_container.querySelector('#to_message').setAttribute('maxlength', this.toFieldLimit);
        this.form_container.querySelector('#from_message').setAttribute('maxlength', this.fromFieldLimit);
        this.form_container.querySelector('#message').setAttribute('maxlength', this.msgFieldLimit);

        this.form_container.querySelector('[data-character-count]').innerText = `Remaining: ${this.charRemaining}`

      }
    }
  );
}

if (!customElements.get("split-quantity")) {
  customElements.define(
    "split-quantity",
    class SplitQuantity extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector(`[type="checkbox"]`);
        this.giftmessage = this.parentElement.querySelector('gift-message')
        this.quantitySelector = this.parentElement.querySelector(`[name="quantity"]`)
      }
      connectedCallback() {
        if (!this.giftmessage) {return}
        this.checkbox.addEventListener("change", () => {
          if (this.checkbox.checked) {
            this.giftmessage.querySelector('[data-disclaimer]').style.display = 'block'
          } else {
            this.giftmessage.querySelector('[data-disclaimer]').style.display = 'none'
          }
        });
        this.quantitySelector.addEventListener("change", (e) => {
          
          let quant = Number(e.target.value)
          if (quant && quant > 1) {
            this.style.display = "block"
          } else {
            this.style.display = "none"
            this.checkbox.checked = false
            this.giftmessage.querySelector('[data-disclaimer]').style.display = 'none'
          }
        })
      }
    }
  );
}

$(document).ready(function() {
  $(".product-form__submit").click(function(event) {
    var qty = $(".quantity__input").val();
    if (qty != 1 && $("#splitQtyCheck").is(":checked")) {
      event.preventDefault();
      var id = $('input[name="id"]').val();
      var _image = $('input[name="properties[_image]"]').val();
      var Message = $('textarea[name="properties[Message]"]').val();
      var To = $('input[name="properties[To]"]').val();
      var From = $('input[name="properties[From]"]').val();
      var cartItem = {
        'items': []
      };
      for (var i = 0; i < qty; i++) {
        var currentItem = {
          'id': id,
          'quantity': 1,
          'properties': {
            'Message': Message,
            'To': To,
            'From': From,
            '_image': _image,
            '_rand': Math.floor(
              (Math.random() * 10000) + 1
            )
          }
        }
        cartItem["items"].push(currentItem);
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartItem)
      }).then(response => {
        window.location.reload();
        return response.json();
      }).catch((error) => {
        console.error('Error:', error);
      });
    }
  });
});